import { invitationsEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import type { AcceptInvitationRequestType, MessageResponseType } from "@/types";

export const acceptInvitationHandler = async (
    token: string,
    {
        companyName,
        email,
        name,
        password,
        passwordConfirmation,
        phone,
    }: AcceptInvitationRequestType,
): Promise<MessageResponseType> => {
    const payload = {
        companyName: companyName,
        email: email,
        name: name,
        password: password,
        passwordConfirmation: passwordConfirmation,
        phone: phone,
    };

    const response = await axiosClient.post<MessageResponseType>(
        invitationsEndpoints.accept(token),
        payload,
    );

    return { message: response.data.message };
};
